<template>
	<div>
		<div
      v-if="loader"
      class="fixed inset-0 flex items-center justify-center bg-white z-50"
    >
      <img
        src="@/assets/imgs/tuin_loader_v2.gif"
        alt="cargando..."
        class="w-[500px]"
      >
    </div>

    <ToastAlert
      :is-active="toastAlert"
      :type="typeMsg"
      :message="msg"
      @close="closeToast"
    />

    <div
      v-if="!loader"
      class="h-full w-full flex mb-[86px]"
    >
      <div
        class="only-dest h-auto w-1/4 flex items-center justify-center">
        <ContactLead
          :contactData="contact"
        />
      </div>

      <div
        class="h-auto sm:w-3/4 w-full flex items-center justify-center">
        <div
          class="sm:w-3/4 w-full"
        >
          <GeneralData
            :contactData="contact"
          />

          <TabsComponent
            id="leads-detail"
            v-model="activeTab"
            :tabs="tabs"
          />

          <LeadsRequirementsSection
            v-if="activeTab === 'requirements'"
            :leadId="contact.id"
            :requirements="requirements"
            @requirements-saved="loadProspectData"
          />

          <LeadsCommentsSection
            v-if="activeTab === 'comments'"
            :comments="comments"
            :leadId="contact.id"
            @comment-saved="loadProspectData"
          />

          <LeadsNotesSection
            v-if="activeTab === 'notes'"
            :notes="notes"
            :leadId="contact.id"
            @note-saved="loadProspectData"
          />

          <LeadsCallsSection
            v-if="activeTab === 'calls'"
            :calls="calls"
            :leadId="contact.id"
            @call-saved="loadProspectData"
          />

          <LeadsPropertiesSection
            v-if="activeTab === 'properties'"
            :properties="properties"
            :leadId="contact.id"
            @reloadProperties="reloadProperties"
          />
        </div>
      </div>

      <div
        class="only-mob"
      >
        <FloatingLead
          :contactData="contact"
        />
      </div>
      
    </div>
  </div>
</template>
<script setup>
import { ref, computed, onMounted } from "vue";
import ToastAlert from "@/commond/ToastAlert.vue";
import ContactLead from "@/components/leads/ContactLead.vue";
import GeneralData from "@/components/leads/GeneralData.vue";
import FloatingLead from "@/components/leads/FloatingLead.vue";
import TabsComponent from "@/components/common/TabsComponent.vue";
import LeadsRequirementsSection from "@/components/leads/LeadsRequirementsSection.vue";
import LeadsCommentsSection from "@/components/leads/LeadsCommentsSection.vue";
import LeadsNotesSection from "@/components/leads/LeadsNotesSection.vue";
import LeadsCallsSection from "@/components/leads/LeadsCallsSection.vue";
import LeadsPropertiesSection from "@/components/leads/LeadsPropertiesSection.vue";
import { useRouter, useRoute } from "vue-router";
import { useStore } from "vuex";
import axios from "axios";


const route = useRoute();
const router = useRouter();
const prospectId = computed(() => route.params.prospect_id);
const store = useStore();

let session = computed(() => store.getters.getUserSession);
let loader = ref(false);
let toastAlert = ref(false);
let typeMsg = ref("");
let msg = ref("");
let activeTab = ref('requirements');
const tabs = [
  { value: 'requirements', label: 'Requerimientos' },
  { value: 'comments', label: 'Comentarios' },
  { value: 'notes', label: 'Tareas' },
  { value: 'calls', label: 'Llamadas' },
  { value: 'properties', label: 'Propiedades de interés' }
];
let contact = ref({
  phone: "",
  name: "",
  last_name: "",
  second_last_name: "",
  status: "",
  id: "",
  email: ""
});
let properties = ref({});
let notes = ref({});
let comments = ref();
let calls = ref();
let requirements = ref();

// Cargar datos del prospecto para edición
async function loadProspectData() {
  
  loader.value = true;
  
  try {
    let options = {
      headers: {
        Authorization: `Bearer ${session.value.token_api}`,
      },
    };

    let url_link = `${process.env.VUE_APP_API_BASE_URL}/broker/lead/${prospectId.value}`;

    const response = await axios.get(url_link, options);

    if (response.status == 401) {
      store.dispatch("clearUserSession");
      router.push({ name: 'login' });
      return;
    }

    if (response.status == 200) {
      let responseData = response.data.resp.info;
      comments.value = response.data.resp.comments;
      properties.value = response.data.resp.properties;
      notes.value = response.data.resp.notes;
      calls.value = response.data.resp.calls;
      requirements.value = response.data.resp.requirements;

      contact.value = {
        phone: responseData.phone,
        name: responseData.name,
        last_name: responseData.last_name,
        second_last_name: responseData.second_last_name,
        status: responseData.status,
        id: responseData.id,
        email: responseData.email
      };
    }
  } catch (error) {
    console.error("Error fetching data:", error);
    showToast('danger', 'Error al cargar los datos del prospecto');
  }
  
  loader.value = false;
}

// Recargar solo las propiedades sin mostrar loader
async function reloadProperties() {
  try {
    let options = {
      headers: {
        Authorization: `Bearer ${session.value.token_api}`,
      },
    };

    let url_link = `${process.env.VUE_APP_API_BASE_URL}/broker/lead/${prospectId.value}`;

    const response = await axios.get(url_link, options);

    if (response.status == 200) {
      properties.value = response.data.resp.properties;
    }
  } catch (error) {
    console.error("Error fetching properties:", error);
  }
}

async function showToast(type, message) {
  toastAlert.value = true;
  typeMsg.value = type;
  msg.value = message;

  setTimeout(() => {
    closeToast();
  }, 3000);
}

async function closeToast() {
  toastAlert.value = false;
  typeMsg.value = "";
  msg.value = "";
}

onMounted(async () => {
  await loadProspectData();
});
</script>